import { round } from './round';

export const getMinimumDisplayQuantity = (quantity: number, minimumDisplayValue: number = 0.01): string => {
  const result = round(quantity, 4);

  return result < minimumDisplayValue && result !== 0 ? minimumDisplayValue.toFixed(2) : result.toFixed(4);
};
